import React, { useState } from 'react';
import {
  ProcessContainer,
  ProcessContent,
  TopSection,
  AvatarGroup,
  MainTitle,
  Subtitle,
  Description,
  VideoSection,
  VideoContainer,
  VideoPlaceholder,
  VideoNavigation,
  NavDot,
  BottomSection, 
  SectionTitle,  
  SectionSubtitle, 
  StepsContainer,  
  StepNumber,      
  WomanSection,    
  WomanImage,      
  FloatingCard,    
  CardTitle,       
  CardDescription, 
  TrustSection,    
  TrustTitle,      
  TrustCards,      
  TrustCard       
} from './styles';

import avatarGroupImage from '../../../assets/images/Frame.png';
import personSmilingImage from '../../../assets/images/person.png';
import MarketplaceSection from '../MarketplaceSection'; 
import FAQSection from '../FAQSection';            

const ProducerProcess = () => {
  // Estado para controlar o vídeo ativo
  const [activeVideo, setActiveVideo] = useState(0);
  
  // Lista de vídeos
  const videos = [
    { id: 0, title: 'Video 1', url: 'https://youtu.be/bZbrT2V7PoA' },
    { id: 1, title: 'Video 2', url: 'https://youtu.be/4wgjOciqqFA' },
    { id: 2, title: 'Video 3', url: 'https://youtu.be/sIFkQvB31qI' }
  ];
  
  
  const nextVideo = () => setActiveVideo((prev) => (prev + 1) % videos.length);
  const prevVideo = () => setActiveVideo((prev) => (prev - 1 + videos.length) % videos.length);
  
  // Função para selecionar um vídeo
  const selectVideo = (index) => setActiveVideo(index);
  
  // Função para obter a ordem dos vídeos
  const getVideoOrder = () => {
    const result = [];
    for (let i = 0; i < videos.length; i++) {
      const position = (i - activeVideo + videos.length) % videos.length;
      if (position === videos.length - 1) {
        result.push(-1);
      } else if (position === 1) {
        result.push(1);
      } else {
        result.push(position);
      }
    }
    return result;
  };
  const videoOrder = getVideoOrder();

  return (
    <ProcessContainer>
      <ProcessContent>
        <TopSection>       
          <AvatarGroup>
            <img src={avatarGroupImage} alt="Grupo de personas" />
          </AvatarGroup>
          
          <MainTitle>
            Floqss activa un canal de ventas único con pago contraentrega. Aumenta tus ingresos llevando tus productos digitales a quienes nunca pudieron comprar online.
          </MainTitle>
          
          <Subtitle>
           Nuestro modelo funciona donde otros fallan.
          </Subtitle>
          
          <Description>
            Millones de personas que nunca compraron online agora podem acessar seus produtos.
          </Description>
          
          <VideoSection>
            <VideoContainer>
              {videos.map((video, index) => {
                const position = videoOrder[index];
                return (
                  <VideoPlaceholder 
                    key={video.id} 
                    position={position}
                    url={video.url}
                    onClick={() => {
                      if (position === 1) {
                        // Clique no vídeo da direita - avançar
                        nextVideo();
                      } else if (position === -1) {
                        // Clique no vídeo da esquerda - voltar
                        prevVideo();
                      } else if (position === 0) {
                        // Vídeo central já está rodando
                      }
                    }}
                  >
                    {position === 0 ? (
                      <iframe
                        width="100%"
                        height="100%"
                        src={`https://www.youtube.com/embed/${video.url.split('/').pop()}?controls=0`}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: '10px' }} // Ajuste o valor conforme o border-radius do VideoPlaceholder
                      ></iframe>
                    ) : (
                      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <img 
                          src={`https://img.youtube.com/vi/${video.url.split('/').pop()}/hqdefault.jpg`} 
                          alt={video.title} 
                          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }} 
                        />
                        {/* <PlayButton>▶</PlayButton> */}
                      </div>
                    )}
                  </VideoPlaceholder>
                );
              })}
            </VideoContainer>
            <VideoNavigation>
              {videos.map((video, index) => (
                <NavDot 
                  key={video.id} 
                  active={activeVideo === index} 
                  onClick={() => selectVideo(index)}
                />
              ))}
            </VideoNavigation>
          </VideoSection>
        </TopSection>
        <BottomSection> 
          <SectionTitle>¿Cómo funciona vender com <strong>Floqss</strong>?</SectionTitle>
          <SectionSubtitle>Activa una nueva vía de ventas con alcance masivo, sin riesgo y sin cambios en tu operación.</SectionSubtitle>
          
          <StepsContainer>
            <WomanSection>
              <WomanImage src={personSmilingImage} alt="Mujer" />
              
              <FloatingCard className="step1">
                <StepNumber>1</StepNumber>
                <CardTitle>Publica tu infoproducto</CardTitle>
                <CardDescription>
                  Sube tu curso, ebook ou mentoría em minutos. Configure seu preço, envie seu conteúdo e ative a opção de pagamento na entrega em sua estrutura de vendas para expandir seu alcance.
                </CardDescription>
              </FloatingCard>
              
              <FloatingCard className="step2">
                <StepNumber>2</StepNumber>
                <CardTitle>Floqss gerencia a logística e o acesso</CardTitle>
                <CardDescription>
                  Nós cuidamos de armazenar seu conteúdo digital, imprimir e entregar o acesso físico ao seu cliente por meio de transportadoras parceiras. Sem complicações, sem integrações externas.
                </CardDescription>
              </FloatingCard>
              
              <FloatingCard className="step3">
                <StepNumber>3</StepNumber>
                <CardTitle>Receba seus ganhos de forma segura</CardTitle>
                <CardDescription>
                  Quando o cliente recebe e paga em dinheiro, o dinheiro entra na sua Wallet Floqss pronto para retirada.  Só cobramos pelo nosso serviço se a venda for concretizada. Sem mensalidades ou taxas ocultas.
                </CardDescription>
              </FloatingCard>
            </WomanSection>
          </StepsContainer>
          
          <TrustSection>
            <TrustTitle>Seu cliente não confia em ninguém. Por isso confia na Floqss.</TrustTitle>
            <TrustCards>
              <TrustCard>
                <div className="icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4>Proteção real, sem promessas</h4>
                <p>A Floqss protege seu produto e o dinheiro da sua venda. Ninguém tem acesso até que o cliente pague, e você vê cada passo em tempo real.</p>
              </TrustCard>
              <TrustCard>
                <div className="icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
                <h4>Entregas com respaldo</h4>
                <p>Coordenamos com as principais transportadoras da Colômbia e te damos o controle visual de cada envio. Sem chamadas, sem dúvidas.  </p>
              </TrustCard>
              <TrustCard>
                <div className="icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 11H15M9 15H15M17 3V5M7 3V5M6 9H18M6 9V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V9M6 9V7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="20" cy="4" r="2" fill="#00ff00"/>
                  </svg>
                </div>
                <h4>Suporte automatizado para seu cliente</h4>
                <p>Enquanto você vende, nós o guiamos. Cada comprador recebe alertas por WhatsApp e e-mail em cada etapa, sem que você precise mover um dedo.</p>
              </TrustCard>
            </TrustCards>
          </TrustSection>
        </BottomSection> 
      </ProcessContent>
      <MarketplaceSection />
      <FAQSection />

    </ProcessContainer>
  );
};

export default ProducerProcess;